"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Consumer = /** @class */ (function () {
    function Consumer(props) {
        this.defaultSectionIds = [];
        this.isFamilyMode = false;
        this.isEligibleCoachConso = false;
        this.defaultFamilyId = "";
        this.clientId = props.clientId;
        this.firstName = props.firstName;
        this.lastName = props.lastName;
        this.civilityCode = props.civilityCode;
        this.categoryCode = props.categoryCode;
        this.socialReason = props.socialReason;
        this.siren = props.siren;
        this.roleCode = props.roleCode;
        this.regionCode = props.regionCode;
        this.tenantId = props.tenantId;
        this.defaultContractId = props.defaultContractId;
        this.defaultDeliveryPointId = props.defaultDeliveryPointId;
        this.defaultSectionId = props.defaultSectionId;
        this.defaultSectionIds = props.defaultSectionIds;
        this.isFamilyMode = props.isFamilyMode;
        this.isEligibleCoachConso = props.isEligibleCoachConso;
        this.pairingTechnologyCode = props.pairingTechnologyCode;
        this.defaultFamilyId = props.defaultFamilyId;
        this.email = props.email;
        this.telephone = props.telephone;
        this.clientReference = props.clientReference;
        this.defaultCustomerAccountId = props.defaultCustomerAccountId;
        this.contactByMobile = props.contactByMobile;
        this.contactByEmail = props.contactByEmail;
        this.isContractTerminated = props.isContractTerminated;
        this.contractTerminationDate = props.contractTerminationDate;
        this.contractStatusCode = props.contractStatusCode;
        this.isEligibleNewFeaturesMessage = props.isEligibleNewFeaturesMessage;
        this.isMultiTargetAlertsEnabled = props.isMultiTargetAlertsEnabled;
    }
    return Consumer;
}());
exports.default = Consumer;
